
<template>
  <div class="question-container">
    <div v-for="(item, index) in questionnaireResultList" class="question-item" :key="index">
      <Question
        :class="item.hm_rate && item.hm_rate.length > 0 && 'has-rating'"
        :questionName="item.title"
        :questionType="item.type"
        :answer="formatValue(item)"
        :videoResourceKey="item.answer_file_key"
        :isHr="isHr"
        :hideAnswer="hideAnswer"
        :questionLabelI18nKey="questionLabelI18nKey"
        :answerLabelI18nKey="answerLabelI18nKey"
        :videoLabelI18nKey="videoLabelI18nKey"
        :noteLabelI18nKey="noteLabelI18nKey"
        @videoPlayIconClick="handleVideoPlayIconClick(item, $event)"
        @viewAttachmentBtnClick="handleViewAttachmentBtnClick(item, $event)"
      >
      </Question>
      <div v-if="item.hm_rate && item.hm_rate.length > 0" class="rating-container">
        <Rating
          v-for="(rate, index) in item.hm_rate"
          :key="index"
          :time="rate.invite_record.submit_time"
          :comment="rate.comment"
          :name="rate.invite_record.hire_manager.full_name"
          :rate="rate.rate"
        ></Rating>
        <div class="total-score">{{ formatRateScore(item.hm_rate_avg) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Question from './question.vue'
import Rating from './rating.vue'

const SELECT_TYPE = ['multiple_select', 'single_select', 'dropdown', 'checkbox']

export default {
  components: {
    Question,
    Rating
  },
  props: {
    questionnaireResultList: {
      type: Array,
      required: true
    },
    isHr: {
      type: Boolean,
      default: false
    },
    hideAnswer: {
      type: Boolean,
      default: false
    },
    questionLabelI18nKey: {
      default: 'admin.application.candidate.label.questionnaireQuestion'
    },
    answerLabelI18nKey: {
      default: 'admin.application.candidate.label.answer'
    },
    videoLabelI18nKey: {
      default: 'admin.application.candidate.label.video'
    },
    noteLabelI18nKey: {
      default: 'admin.application.candidate.label.note'
    }
  },
  data () {
    return {
      expire: null
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    async handleVideoPlayIconClick (question, $event) {
      if (!question?.title || !question.answer_file_key) {
        return
      }
      this.$emit('videoPlayIconClick', question, $event)
    },
    async handleViewAttachmentBtnClick (question, $event) {
      if (!question.answer_file_key) {
        return
      }
      this.$emit('viewAttachmentBtnClick', question, $event)
    },
    formatValue (question) {
      if (SELECT_TYPE.includes(question.type)) {
        return _.map(question.answer_option, 'description').join(', ')
      }
      return question.answer_value
    },
    formatRateScore (score) {
      return _.round(score, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.question-container {
  .question-item {
    position: relative;
    margin-top: 50px;

    .has-rating {
      background: #FBFBFB;
    }

    .rating-container {
      margin-top: -1px;
    }

    .total-score {
      position: absolute;
      right: 15px;
      top: 15px;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      border: 2px solid #0096cc;
      color: #0096cc;
      border-radius: 50%;
      background-color: #fff;
    }

    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
